import {OrgGroupDto} from "./org-group.dto";
import {OrgDto} from "./org.dto";
import {State} from "../../libs/enum/state.enum";
import {isDefined} from "../../libs/utils/epic.utils";

export class OrgUserDto {

  public readonly id!: string;
  public enabled!: boolean;
  public validFrom: Date | undefined;
  public validUntil: Date | undefined;
  // INVITED = User is invited and must accept the invitation
  // CONFIRMED = Confirmed user of the org
  public readonly state!: State;
  public email: string | undefined;
  public readonly userId: string | undefined;
  public readonly fullName: string | undefined;
  public readonly groups: OrgGroupDto[] = [];
  public readonly groupCount: number | undefined; // Optional: is set if needed
  public readonly org: OrgDto | undefined;

  constructor(init?: Partial<OrgUserDto> | undefined) {
    Object.assign(this, init);
    if (init?.validFrom) {
      this.validFrom = new Date(init.validFrom);
    }
    if (init?.validUntil) {
      this.validUntil = new Date(init.validUntil);
    }
    if (init?.groups) {
      this.groups = init.groups.map((i) => new OrgGroupDto(i))
        .sort((i1, i2) => {
          const name1 = i1.name ?? '';
          const name2 = i2.name ?? '';
          return name1 < name2 ? -1 : name1 > name2 ? 1 : 0;
        });
      this.groupCount = this.groups.length;
    } else {
      this.groups = [];
      // Do not set 'groupCount', there are cases where 'groups' are not passed even if they exist
    }
    if (init?.org) {
      this.org = new OrgDto(init.org);
    }
  }

  public isEditable(): boolean {
    return true;
  }

  public isEnabled(): boolean {
    return this.enabled;
  }

  public isInvited(): boolean {
    return this.state === State.INVITED;
  }

  public isConfirmed(): boolean {
    return this.state === State.CONFIRMED;
  }

  // Used in Table-Action
  // noinspection JSUnusedGlobalSymbols
  public hasGroups(): boolean {
    return this.groups.length > 0 || (isDefined(this.groupCount) && this.groupCount > 0);
  }

  public isAllowSwitchToOrg(): boolean {
    return isDefined(this.org) && this.org.isEnabled() && this.org.hasPermissions()
      && this.isConfirmed() && !this.isInvited();
  }
}
